enum SupportedCountry {
  DE = 'de',
  GB = 'uk',
  IT = 'it',
  PL = 'pl',
  ES = 'es',
  NL = 'nl',
  AT = 'at',
  FR = 'fr',
  HU = 'hu',
  BE = 'be',
  CH = 'ch',
  DK = 'dk',
  SE = 'se',
  FI = 'fi'
}

export default SupportedCountry;
